/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Row_ReminderInputs */

const en_us2_profile_row_reminder = /** @type {(inputs: Profile_Row_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workout reminder`)
};

const pt_br2_profile_row_reminder = /** @type {(inputs: Profile_Row_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lembrete de treino`)
};

const es_419_profile_row_reminder = /** @type {(inputs: Profile_Row_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recordatorio de entrenamiento`)
};

const pt_pt2_profile_row_reminder = /** @type {(inputs: Profile_Row_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lembrete de treino`)
};

const fr_fr2_profile_row_reminder = /** @type {(inputs: Profile_Row_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rappel d'entraînement`)
};

const de_de2_profile_row_reminder = /** @type {(inputs: Profile_Row_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainingserinnerung`)
};

const it_it2_profile_row_reminder = /** @type {(inputs: Profile_Row_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promemoria di allenamento`)
};

/**
* | output |
* | --- |
* | "Workout reminder" |
*
* @param {Profile_Row_ReminderInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_row_reminder = /** @type {((inputs?: Profile_Row_ReminderInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Row_ReminderInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_row_reminder(inputs)
	if (locale === "es-419") return es_419_profile_row_reminder(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_row_reminder(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_row_reminder(inputs)
	if (locale === "de-DE") return de_de2_profile_row_reminder(inputs)
	if (locale === "it-IT") return it_it2_profile_row_reminder(inputs)
	return en_us2_profile_row_reminder(inputs)
});
export { profile_row_reminder as "profile.row_reminder" }